import dayjs from "dayjs";
import { getLogs } from "../../../../services/requests/ApiRequests";
const { useState, useEffect } = require("react");

export const useLogFetch = (startDate, endDate) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!startDate || !endDate) return;

        const fetchLogs = async () => {
            setLoading(true);
            setError(null);

            try {
                const formattedStartDate =
                    dayjs(startDate).format("YYYY-MM-DD");
                const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");

                const response = await getLogs(
                    formattedStartDate,
                    formattedEndDate
                );

                if (Array.isArray(response?.data)) {
                    setLogs(response.data);
                } else if (
                    response &&
                    typeof response === "object" &&
                    Array.isArray(response.detail)
                ) {
                    setLogs(response.detail);
                } else if (response && typeof response === "object") {
                    const logsArray = Object.values(response).filter(
                        (item) =>
                            typeof item === "object" &&
                            item !== null &&
                            item.hasOwnProperty("_id")
                    );

                    setLogs(logsArray.length > 0 ? logsArray : []);
                } else {
                    setLogs([]);
                }
            } catch (err) {
                console.error("Error fetching logs:", err);
                setError("Failed to fetch logs. Please try again.");
                setLogs([]);
            } finally {
                setLoading(false);
            }
        };

        fetchLogs();
    }, [startDate, endDate]);

    return { logs, loading, error };
};
